import {EntityData, field, identifier, Image} from "@fedeltapointofsale/data-client";

export class UncachedImageData extends EntityData<UncachedImageData> implements Image {
    private _image: string;

    @identifier id: number;

    @field get image(): string {
        return this._image;
    }

    set image(image: string) {
        if (image !== this._image) {

            // Clear the image id only if we had an existing image,
            // otherwise, if we have an id, this will be a lazy load of the image data.
            if (this._image != undefined) {
                this.id = undefined;
            }

            this._image = image;
        }
    }

    // Images are immutable, so if the image id is set, there is no need to send the image itself.
    override isTransient(key: string | symbol): boolean {
        return key === "image" ? !!this.id : super.isTransient(key);
    }
}
